import { NgModule } from '@angular/core';
import { ReportSummaryItemComponent } from '../components/report-summary-item/report-summary-item';
import { IonicModule } from 'ionic-angular';
import { TranslateModule } from '@ngx-translate/core';
import { SupplierSelectorComponentModule } from './supplier-selector/supplier-selector.module';

@NgModule({
  declarations: [
    ReportSummaryItemComponent,
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild(),
  ],
  exports: [
    ReportSummaryItemComponent,
    SupplierSelectorComponentModule
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/modules/shared.module.ts